import { Navigate } from "react-router-dom";

export function BillingRedirect() {
  return <Navigate to="/?panel=billing&tab=invoices" replace />;
}
